// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"0bad7a54","142":"978d1633","488":"bd4aa51b","546":"4961ca31","587":"66c9653e","630":"35ebabc3","645":"a0b44988"}[chunkId] + ".chunk.js";
};